import React from 'react';
import { makeStyles } from '@mui/styles';
import { WithDragDrop } from 'components/@layout/WithDragDrop';
import { lessonsData } from '../../../LessonPlanner/__mock_data__/tour';
import { LessonPlannerMain } from '../../../LessonPlanner/components/LessonPlannerMain';
import TourContainer from '../../Tour';

const STEP_MAP = {
  topBarGroup: { domId: 'mainNavbar' },
  'actionBarGroup.viewStudentProgress': { domId: 'viewStudentProgress' },
  'actionBarGroup.viewAssignments': { domId: 'viewAssignments' },
  'actionBarGroup.createAssignment': { domId: 'createAssignment' },
  lessonCardGroup: { domId: 'lessonCardGroup-1' }
};

export const LessonPlannerTour: React.FC = () => {
  const classes: any = useStyles();

  const getTourBtnActionGroupStyle = currentStep => {
    return { ...(currentStep?.groupName === 'lessonCardGroup' && { left: '50%', top: '120px' }) };
  };
  return (
    <TourContainer
      tourName={'lessonPlanner'}
      stepMap={STEP_MAP}
      getTourBtnActionGroupStyle={getTourBtnActionGroupStyle}
    >
      <div className={classes.dummyPlanner}>
        <WithDragDrop>
          <LessonPlannerMain
            lessons={lessonsData}
            selectedView={'week'}
            onMoveCard={() => undefined}
            gridProps={{}}
            title={'test'}
            lessonWeek={`Week ${5}`}
            handleNextClick={() => undefined}
            handlePreviousClick={() => undefined}
            handleGoToTodayClick={() => undefined}
          />
        </WithDragDrop>
      </div>
    </TourContainer>
  );
};

const useStyles = makeStyles((): any => {
  return {
    dummyPlanner: {
      flex: '1 0 100%',
      width: '100%',
      height: '100%'
    }
  };
});
